// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-3MSXc","btnDetail":"index-btnDetail-icWv6"};